/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-25 18:20:43
 * @LastEditors: Json Chen
 * @LastEditTime: 2023-03-27 08:45:40
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductAlias/EditPage/CloneButton/index.tsx
 */
import React from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import Button from 'src/components/CloneButton';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
import { initAliasDetail, initNewAlias } from '../slice';

const CloneBtn = (props) => {
  const params: any = useParams();
  const _d = useDispatch();
  const { salesChannelProductUuid, aliasUuid } = params;
  const { disabled } = props;

  const handleOnClick = () => {
    if (aliasUuid && aliasUuid !== 'new') {
      _d(
        initAliasDetail({
          body: aliasUuid,
          params: {
            [EnumSalesChannelMultiLanguage.multiLanguageUsePrimaryLanguage]:
              true,
          },
        }),
      );
    } else {
      _d(
        initNewAlias({
          body: salesChannelProductUuid,
          params: {
            [EnumSalesChannelMultiLanguage.multiLanguageUsePrimaryLanguage]:
              true,
          },
        }),
      );
    }
  };
  return <Button onClick={handleOnClick} disabled={disabled} />;
};
export default CloneBtn;
